import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7705a2a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative date-range-picker" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute right-3 top-2 text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    })
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "absolute mt-2 bg-white rounded-lg shadow-lg border p-4 z-50"
}
const _hoisted_6 = { class: "flex justify-between items-center mb-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "grid grid-cols-7 gap-1" }
const _hoisted_13 = ["onClick"]

import { ref, computed, onMounted, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangePicker',
  emits: ['update:dateRange'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const showCalendar = ref(false);
const currentDate = ref(new Date());
const startDate = ref<Date | null>(null);
const endDate = ref<Date | null>(null);
const selecting = ref<'start' | 'end'>('start');

const currentYear = computed(() => currentDate.value.getFullYear());
const currentMonth = computed(() => currentDate.value.getMonth());
const currentMonthName = computed(() => {
    return new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(currentDate.value);
});

const weekDays = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

const calendarDays = computed(() => {
    const days: Date[] = [];
    const firstDay = new Date(currentYear.value, currentMonth.value, 1);
    const lastDay = new Date(currentYear.value, currentMonth.value + 1, 0);
    
    const firstDayOfWeek = firstDay.getDay();
    for (let i = firstDayOfWeek; i > 0; i--) {
        days.push(new Date(currentYear.value, currentMonth.value, -i + 1));
    }
    
    for (let i = 1; i <= lastDay.getDate(); i++) {
        days.push(new Date(currentYear.value, currentMonth.value, i));
    }
    
    const remainingDays = 42 - days.length;
    for (let i = 1; i <= remainingDays; i++) {
        days.push(new Date(currentYear.value, currentMonth.value + 1, i));
    }
    
    return days;
});

const formatDateRange = computed(() => {
    if (!startDate.value && !endDate.value) {
        return '';
    }

    if (startDate.value && !endDate.value) {
        return `Desde ${formatDate(startDate.value)}`;
    }

    if (startDate.value && endDate.value) {
        return `${formatDate(startDate.value)} - ${formatDate(endDate.value)}`;
    }

    return '';
});

const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(date);
};

const toggleCalendar = () => {
    showCalendar.value = !showCalendar.value;
};

const previousMonth = () => {
    currentDate.value = new Date(currentYear.value, currentMonth.value - 1);
};

const nextMonth = () => {
    currentDate.value = new Date(currentYear.value, currentMonth.value + 1);
};

const selectDate = (date: Date) => {
    if (selecting.value === 'start' || !startDate.value) {
        startDate.value = new Date(date);
        selecting.value = 'end';
        if (endDate.value && startDate.value > endDate.value) {
            endDate.value = null;
        }
    } else {
        if (date < startDate.value) {
            endDate.value = startDate.value;
            startDate.value = new Date(date);
        } else {
            endDate.value = new Date(date);
        }
        selecting.value = 'start';
    }
};

const isSelected = (date: Date) => {
    return (
        startDate.value?.toDateString() === date.toDateString() ||
        endDate.value?.toDateString() === date.toDateString()
    );
};

const isInRange = (date: Date) => {
    if (!startDate.value || !endDate.value) return false;
    return date > startDate.value && date < endDate.value;
};

const clearDates = () => {
    startDate.value = null;
    endDate.value = null;
    selecting.value = 'start';
    emit('update:dateRange', {
        startDate: null,
        endDate: null
    });
    showCalendar.value = false;
};

const applyDates = () => {
    emit('update:dateRange', {
        startDate: startDate.value,
        endDate: endDate.value
    });
    showCalendar.value = false;
};

const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.date-range-picker')) {
        showCalendar.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "text",
        value: formatDateRange.value,
        readonly: "",
        placeholder: "Seleccionar rango de fechas",
        class: "w-72 px-4 py-2 border rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 bg-white",
        onClick: toggleCalendar
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    (showCalendar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: previousMonth,
              class: "p-1 hover:bg-gray-100 rounded"
            }, _hoisted_8),
            _createElementVNode("span", _hoisted_9, _toDisplayString(currentMonthName.value) + " " + _toDisplayString(currentYear.value), 1),
            _createElementVNode("button", {
              onClick: nextMonth,
              class: "p-1 hover:bg-gray-100 rounded"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
              return _createElementVNode("div", {
                key: day,
                class: "text-center text-sm font-semibold text-gray-600"
              }, _toDisplayString(day), 1)
            }), 64)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (date) => {
              return (_openBlock(), _createElementBlock("div", {
                key: date.toISOString(),
                onClick: ($event: any) => (selectDate(date)),
                class: _normalizeClass([
                        'text-center p-2 cursor-pointer rounded hover:bg-gray-100',
                        isSelected(date) ? 'bg-green-500 text-white hover:bg-green-600' : '',
                        isInRange(date) ? 'bg-green-100' : '',
                        date.getMonth() !== currentMonth.value ? 'text-gray-400' : ''
                    ])
              }, _toDisplayString(date.getDate()), 11, _hoisted_13))
            }), 128))
          ]),
          _createElementVNode("div", { class: "mt-4 flex justify-end space-x-2" }, [
            _createElementVNode("button", {
              onClick: clearDates,
              class: "px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded"
            }, " Limpiar "),
            _createElementVNode("button", {
              onClick: applyDates,
              class: "px-4 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600"
            }, " Aplicar ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})